import React, { FC } from 'react';
import MuiMenuItem from '@material-ui/core/MenuItem';
import { MenuItemProps } from './types';
import useStyles from './styles';

const MenuItem: FC<MenuItemProps> = props => {
  const {
    children,
    backgroundColor,
    color,
    hoverBackgroundColor,
    hoverColor,
    ...restProps
  } = props;

  const classes = useStyles(props);

  return (
    <MuiMenuItem {...restProps} className={classes.root}>
      {children}
    </MuiMenuItem>
  );
};

export default MenuItem;
